module.exports = __webpack_public_path__ + "assets/img/NVIDIA-b0fb447e.png";